﻿import React, { useCallback, useEffect, useState } from "react";
import { DataDisplayTable } from "components/data-display";
import { Modal, ModalSize } from "components/notifications";

export function TyreModelSpecs({ position, isOpen, onClose }) {
    const [detailHeaderSections, setDetailHeaderSections] = useState([]);
    const columnsPerRow = 4;

    const setUpTyreDetailHeader = useCallback(() => {
        if (!position) return [];

        const fields = [
            { header: "Mileage", value: position.mileage, key: "mileage" },
            { header: "No Mileage Access", value: position.hasNoMileageAccess, key: "hasNoMileageAccess" },
            { header: "Axle Number", value: position.axleNumber, key: "axleNumber" },
            { header: "Tyre Position", value: position.tyrePosition, key: "tyrePosition" },
            { header: "Brand", value: position.brand, key: "brand" },
            { header: "Dimension", value: position.dimension, key: "dimension" },
            { header: "Model", value: position.model, key: "model" },
            { header: "Is Damaged", value: position.isDamaged, key: "isDamaged" },
            { header: "Serial Number", value: position.serialNumber, key: "serialNumber" },
            { header: "Serial Unreadable", value: position.isSerialUnreadable, key: "isSerialUnreadable" },
            { header: "DOT", value: position.dot, key: "dot" },
            { header: "DOT Unreadable", value: position.isDOTUnreadable, key: "isDOTUnreadable" },
            { header: "Retreaded", value: position.isRetreaded, key: "isRetreaded" },
            { header: "Regrooved", value: position.isRegrooved, key: "isRegrooved" },
            { header: "Tread Depth", value: position.treadDepth, key: "treadDepth" },
            { header: "Pressure", value: position.pressure, key: "pressure" },
            { header: "Comment", value: position.comment, key: "comment" },
            { header: "Width", value: position.width, key: "width" },
            { header: "Aspect Ratio", value: position.aspectRatio, key: "aspectRatio" },
            { header: "Radial", value: position.radial, key: "radial" },
            { header: "Rim Diameter", value: position.rimDiameter, key: "rimDiameter" },
            { header: "Load Index", value: position.loadIndex, key: "loadIndex" },
            { header: "Speed Index", value: position.speedIndex, key: "speedIndex" },
            { header: "Fuel Consumption Class", value: position.fuelConsumptionClass, key: "fuelConsumptionClass" },
            { header: "Braking Performance Class", value: position.brakingPerformanceClass, key: "brakingPerformanceClass" },
            { header: "Noise Class", value: position.noiseClass, key: "noiseClass" },
            { header: "Noise Level", value: position.noiseLevel, key: "noiseLevel" },
            { header: "Vehicle Class", value: position.vehicleClass, key: "vehicleClass" },
            { header: "Regulation Number", value: position.regulationNumber, key: "regulationNumber" },
            { header: "M+S Mark", value: position.hasMsMark, key: "hasMsMark" },
            { header: "3PMSF Mark", value: position.has3pmsfMark, key: "has3pmsfMark" },
            { header: "Ice Mark", value: position.hasIceMark, key: "hasIceMark" },
            { header: "Original Tread Depth", value: position.originalTreadDepth, key: "originalTreadDepth" },
        ];


        return fields.map(field => {
            let displayValue = field.value;

            if (displayValue === null || displayValue === undefined) {
                displayValue = "N/A";
            } else if (typeof displayValue === "boolean") {
                displayValue = displayValue ? "Yes" : "No";
            }

            return {
                ...field,
                value: displayValue
            };
        });
    }, [position]);



    useEffect(() => {
        setDetailHeaderSections(setUpTyreDetailHeader());
    }, [setUpTyreDetailHeader]);

    return (
        <div>
            <Modal isOpen={isOpen} title="Tyre Model Details" size={ModalSize.LARGE} onClose={onClose} >
                <DataDisplayTable
                    data={detailHeaderSections}
                    displayInRows={false}
                    columnsPerRow={columnsPerRow}
                />
            </Modal>
        </div>
    );
}
